import { cardImageSources, type GenericCharacter } from './types'

export const genericBruja: GenericCharacter = {
  id: 'generic-bruja',
  enabled: true,
  order: 10,
  displayName: 'Lila',
  icon: '🧙‍♀️',
  imageSources: cardImageSources('generic-bruja'),
}
